@if (values) {
  <span class="row-value" [class.row-value--pending]="pending">
    @if (labelRow !== null) {
      <span class="row-value__label">
        {{ 'TRANS__IMPORT__LIVE_PREVIEW__ROW_VALUE' | translate: {row: labelRow} }}
      </span>
    }
    @if (values.length) {
      <b>{{ values.join(' · ') }}</b>
    } @else {
      <span class="row-value__empty">{{ 'TRANS__IMPORT__LIVE_PREVIEW__EMPTY_LINE' | translate }}</span>
    }
  </span>
}
